import {
  ActivitiesTypes,
  FollowupFiltersTypes,
} from 'store/modules/followup_online_search_store/types';
import followupOnlineSearchInitialState from 'store/modules/followup_online_search_store/initial_state';
import { FollowupTypes } from './types';

interface FollowupParamsTypes {
  id: string | null;
  tipo_orgao_id: number[];
  processo: string;
  objeto: string;
  orgao_endereco: string;
  nome_orgao: string;
  notice_number: string;
  'data_fonte[from]': string | null;
  'data_fonte[to]': string | null;
  orgao_estado_id: number[];
  cities_ids: string[];
  modalities_ids: number[];
  atividade: string[];
  page: number;
  per_page: number;
  favorite_scope?: string | null;
  favorite?: boolean | null;
  managed?: boolean | null;
  archived?: boolean | null;
  order?: string | null;
  order_direction?: string | null;
  sintese: string;
  access_token?: string | null;
}

interface getFollowupParams {
  filters?: FollowupFiltersTypes;
  page?: number;
  per_page?: number;
  activities_list: Array<ActivitiesTypes>;
  access_token?: string | null;
  favorite?: boolean | null;
}

const followupParams = (
  filters: FollowupFiltersTypes,
  page: number,
  per_page: number,
  activities_list: Array<ActivitiesTypes>,
  access_token: string | null,
  favorite?: boolean | null,
) => {
  const followup_params: FollowupParamsTypes = {
    id: filters.id ? filters.id : null,
    tipo_orgao_id: filters.publicBodyTypes?.map((option) => option.value),
    processo: filters.processNumber,
    objeto: filters.object,
    orgao_endereco: filters.address,
    nome_orgao: filters.publicBody,
    notice_number: filters.noticeNumber,
    'data_fonte[from]': filters.includeDateRange.from,
    'data_fonte[to]': filters.includeDateRange.to,
    orgao_estado_id: filters.states?.map((option) => option.value),
    cities_ids: filters.cities?.map((option) => option.value),
    modalities_ids: filters.modalities?.map((option) => option.value),
    atividade:
      filters.activities.length === 0
        ? activities_list?.map((option) => option.codigo)
        : filters.activities?.map((option) => option.codigo),
    page,
    per_page,
    sintese: filters.summary,
    access_token: null,
  };
  if (access_token !== null) followup_params.access_token = access_token;
  if (favorite !== null) followup_params.favorite = favorite;

  return followup_params;
};

export const getFollowups = (params: getFollowupParams, companyId?: number) => {
  const {
    filters = followupOnlineSearchInitialState.followupOnlineSearch.filters,
    page = 1,
    per_page = 20,
    activities_list,
    access_token = null,
    favorite = null,
  } = params;

  const followup_params = followupParams(
    filters,
    page,
    per_page,
    activities_list,
    access_token,
    favorite,
  );
  return {
    types: [
      FollowupTypes.GET_FOLLOWUPS_REQUEST,
      FollowupTypes.GET_FOLLOWUPS_SUCCESS,
      FollowupTypes.GET_FOLLOWUPS_FAILURE,
    ],
    promise: (client: any) =>
      client.get(`/followups/search.json${companyId ? `?companyId=${companyId}` : ''}`, {
        params: followup_params,
      }),
  };
};
